<script setup lang="ts">
type Props = {
  animation?: object;
  image?: string;
  circleWidth?: string;
  imgWidth?: string;
};

const props = withDefaults(defineProps<Props>(), {
  circleWidth: '80px',
  imgWidth: '40px',
});
</script>

<template>
  <div class="wrapper d-flex justify-center align-center">
    <div class="background"></div>
    <v-sheet
      class="illustration-circle rounded-circle d-flex justify-center align-center"
      :width="props.circleWidth"
      :height="props.circleWidth"
    >
      <div
        class="illustration-inner rounded-circle bg-surface w-100 h-100 d-flex justify-center align-center"
      >
        <lottie-player
          v-if="props.animation"
          autoplay
          loop
          mode="bounce"
          :src="props.animation"
        ></lottie-player>
        <v-img v-else :src="props.image" :max-width="props.imgWidth" class="rounded-circle"></v-img>
      </div>
    </v-sheet>
  </div>
</template>

<style scoped lang="scss">
.wrapper {
  position: relative;
}

.illustration-circle {
  position: relative;
  background: linear-gradient(
    45.01deg,
    #0096ff -0.02%,
    #029caf 21.86%,
    #f59f00 46.86%,
    #f06f38 71.45%,
    #ff2f92 100%
  );
  padding: 1px;
  overflow: hidden;
}

.background {
  position: absolute;
  border: 1px solid black;
  width: 250px;
  height: 30px;
  top: 50%;
  left: 50%;
  background: linear-gradient(
    90deg,
    #0096ff -0.04%,
    #029caf 21.84%,
    #ffa800 46.85%,
    #fe8058 71.44%,
    #ff2f92 100%
  );
  filter: blur(50px);
  transform: translate(-50%, -50%) rotate(-16.66deg);
}
</style>
